import { useState, useEffect } from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../../config/ApiConfig';
import DefaultModal from '../modals/DefaultModal';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import useDefaultModal from '../hooks/useDefaultModal';
import useProgramaSituacao from '../hooks/useProgramaSituacao';

function AcaoModal({ show, onHide, acao, onSuccess }) {
  const [formData, setFormData] = useState({
    cnpjAssociacao: '',
    idPrograma: null,
    id: '',
    descricao: '',
  });
  const [programas, setProgramas] = useState([]);
  const token = localStorage.getItem('token');
  const cnpj = localStorage.getItem('cnpj');
  const { setDefaultModal, showDefaultModal } = useDefaultModal();
  const { isProgramaAtivo } = useProgramaSituacao();
  const [isProgramaInativo, setIsProgramaInativo] = useState(false);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL.PROGRAMA}/all`, {
        params: { cnpjAssociacao: cnpj },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(result => {
        setProgramas(result.data);
      })
      .catch(error => {
        console.error('Erro ao obter programas:', error);
        showDefaultModal('error', 'Erro ao obter programas!');
      });
    if (!show) {
      setFormData({
        cnpjAssociacao: cnpj,
        idPrograma: null,
        id: '',
        descricao: '',
      });
    } else if (acao) {
      setFormData({
        ...acao,
        idPrograma: acao.idPrograma,
        descricao: acao.descricao ? acao.descricao.toUpperCase() : '',
      });
    } else {
      setFormData({
        cnpjAssociacao: cnpj,
        idPrograma: null,
        id: '',
        descricao: '',
      });
    }
  }, [show, acao]);

  useEffect(() => {
    if (formData.idPrograma) {
      const programaAtivo = isProgramaAtivo(formData.idPrograma);
      setIsProgramaInativo(!programaAtivo);
    } else {
      setIsProgramaInativo(false);
    }
  }, [formData.idPrograma, isProgramaAtivo]);

  function handleChange(event) {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value.toUpperCase(),
    });
  }

  function handleSubmit(event) {
    event.preventDefault();
    if (formData.idPrograma && !isProgramaAtivo(formData.idPrograma)) {
      showDefaultModal('error', 'Este programa está ENCERRADO. Não é possível salvar ações para programas encerrados.');
      return;
    }
    const acaoParaSalvar = {
      ...formData,
      cnpjAssociacao: cnpj,
    };
    console.log('Salvando ação: ', acaoParaSalvar);
    axios
      .post(`${API_BASE_URL.ACAO}/save`, acaoParaSalvar, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        onHide();
        showDefaultModal('success', 'O registro foi salvo com sucesso!', () => {
          onSuccess();
        });
      })
      .catch(error => {
        console.error('Erro ao salvar acao:', error);
        showDefaultModal('error', 'Erro ao salvar o registro!');
      });
  }

  return (
    <>
      <Modal show={show} onHide={onHide} centered>
        <Modal.Header
          closeButton
          closeVariant="white"
          className={acao ? 'bg-primary text-white' : 'bg-success text-white'}
          style={{ height: '30px' }}
        >
          <Modal.Title className="fs-5">
            {acao ? 'EDITAR AÇÃO' : 'NOVA AÇÃO'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {isProgramaInativo && (
            <div className="alert alert-warning mb-3" role="alert">
              <i className="bi bi-exclamation-triangle-fill me-2"></i>
              Este programa está <strong>ENCERRADO</strong>. Você pode visualizar os dados, mas não é possível salvar alterações.
            </div>
          )}
          <form onSubmit={handleSubmit}>
            <div className="row g-3">
              <div className="col-md-12 input-group-sm">
                <label className="form-label">Programa</label>
                <select
                  name="idPrograma"
                  className="form-select"
                  value={formData.idPrograma}
                  onChange={handleChange}
                  required
                >
                  <option value="">Selecione...</option>
                  {programas.map(programa => (
                    <option key={programa.id} value={programa.id}>
                      {programa.descricao}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-12 input-group-sm">
                <label className="form-label">Nome da Ação</label>
                <input
                  onChange={handleChange}
                  value={formData.descricao}
                  name="descricao"
                  type="text"
                  className="form-control text-uppercase" // Adiciona classe para exibir em maiúsculas
                  required
                />
              </div>
              <div className="col-md-12 mb-3 input-group-sm d-flex justify-content-end">
                <Button variant="danger" onClick={onHide} className="mx-1">
                  <i className="bi bi-x-lg" /> Cancelar
                </Button>
                <Button type="submit" variant="success" className="mx-1" disabled={isProgramaInativo} title={isProgramaInativo ? 'Programa ENCERRADO - não é possível salvar' : undefined}>
                  <i className="bi bi-check-lg" /> Salvar
                </Button>
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      <DefaultModal {...setDefaultModal} />
    </>
  );
}

export default AcaoModal;
